import rootReducer from "domain/reducer";
// eslint-disable-next-line import/named
import {
  applyMiddleware,
  legacy_createStore as createStore,
  Middleware,
} from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";
import rootSaga from "store/middleware/saga";

const sagaMiddleware = createSagaMiddleware();

const middlewareStack = [sagaMiddleware];

export function makeStoreEnhancer(middleware: Middleware[]) {
  const withMiddleware = applyMiddleware(...middleware);

  if (process.env.NODE_ENV === "development") {
    const composedEnhancer = composeWithDevTools({
      trace: true,
    })(withMiddleware);

    return composedEnhancer;
  }

  return withMiddleware;
}

const storeEnhancer = makeStoreEnhancer(middlewareStack);
const store = createStore(rootReducer, storeEnhancer);

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export default store;
